import { atom } from 'recoil'

/**
 * 簽核的 companyCode
 */
export const approvalCompanyCode = atom<{ [key: string]: any } | undefined>({
  key: 'approvalCompanyCode',
  default: undefined,
})
